import React, {Component} from 'react';
import './SuccessComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';

class SuccessComponent extends Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
    }

    close() {
        this.props.onClose();
    }

    render() {
        let options = {'firstName': this.props.firstName};
        return (
            <div className="SuccessComponent text-center">
                <div className="SvgImage">
                    <svg width="72" height="72" xmlns="http://www.w3.org/2000/svg">
                        <g stroke="#0067DB" fill="none" fillRule="evenodd">
                            <circle strokeOpacity=".2" cx="36" cy="36" r="35.5"/>
                            <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M24 38l10 8 14-20"/>
                        </g>
                    </svg>
                </div>
                <div><h3 className="Header" >{this.props.lingua.read('lex.header.success', options)}</h3></div>
                <p className="SuccessPadding lead">{this.props.lingua.read('lex.signup.success.subtitle')}</p>
                <div className="SuccessButton">
                    <form>
                        <ButtonPrimary label={this.props.lingua.read('button.continue')} onClick={this.close} />
                    </form>
                </div>
            </div>
        );
    }
}

export default SuccessComponent;
